import styled from "styled-components";
import {Card} from "antd";

export const HeaderText = styled.span`
    margin-left: 10px;
`;
export const PasswordCard = styled(Card)`
    margin-top: 20px;
`;
